import { useAppLoader, useLogger } from '@capsicum/common';
import { useAllSearchParams } from '@capsicum/common-web';
import { useWalletConnectContext } from '@capsicum/socios-core-web';
import { useEffect } from 'react';

export const useWalletConnectDigest = () => {
	const { connectWallet } = useWalletConnectContext();
	const logger = useLogger();
	const appLoader = useAppLoader();
	const searchParams = useAllSearchParams();

	// WalletConnect concatenates something like `/wc?uri={uri}` to our web deeplink
	// since we dont have a /wc route, to prevent an error we added this route on next.config.js to be translated to /home

	// Example: from `hhtps://app.integration.socios.com/home?uri={uri}`
	// here we get the uri searchparam `{uri}`
	const wcUri = searchParams.get('uri');

	useEffect(() => {
		if (wcUri) {
			const decodedURI = decodeURIComponent(wcUri);

			if (decodedURI && connectWallet) {
				logger.info('Connecting wallet...');

				try {
					appLoader(connectWallet(decodedURI));
				} catch (err) {
					logger.error(JSON.stringify(err));
				}
			}
		}
	}, [wcUri, connectWallet]);

	return null;
};
